import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import backimg from 'assets/img/generic/hero.jpg';
//import dashboardDark from 'assets/img/generic/dashboard-alt-dark.png';
//import dashboard from 'assets/img/generic/dashboard-alt.png';
import Section from 'components/common/Section';
import AppContext from 'context/Context';
import React, { useContext } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Typewriter } from 'react-simple-typewriter';
import IconButton from 'components/common/IconButton';
import { config } from 'config';

const Hero = () => {
 const {
  config: { isRTL }
 } = useContext(AppContext);

 return (
  <Section className="py-0 overflow-hidden light" image={backimg} position="center bottom" overlay>
   <Row className="justify-content-center align-items-center pt-8 pt-lg-10 pb-lg-9 pb-xl-0">
    <Col md={11} lg={8} xl={4} className="pb-7 pb-xl-9 text-center text-xl-start">
     <IconButton
      as={Link}
      className="mb-4 fs--1 border-2 rounded-pill"
      variant="danger"
      icon={faWhatsapp}
      transform="shrink-3"
      to="#!"
      iconClassName="fs-1"
     >
      Contáctenos
     </IconButton>
     <h1 className="text-white fw-light">
      {config.REACT_APP_SLOGAN[0]}{' '}
      <span className="fw-bold">
       <Typewriter
        words={config.REACT_APP_SLOGAN.slice(1, -1)}
        loop={false}
        cursor={!isRTL ? true : false}
        cursorStyle="|"
        typeSpeed={70}
        deleteSpeed={50}
        delaySpeed={1000}
       />
      </span>
      <br />
      {config.REACT_APP_SLOGAN.slice(-1)}
     </h1>
     <p className="lead text-white opacity-75">{config.REACT_APP_DESCP_HOME}</p>
     <Button
      as={Link}
      variant="outline-light"
      size="lg"
      className="border-2 rounded-pill mt-4 fs-0 py-2"
      to="/authentication/card/register"
     >
      ¡Registrese totalmente gratis!
      <FontAwesomeIcon icon="play" transform="shrink-6 down-1 right-5" />
     </Button>
    </Col>
    <Col xl={{ span: 7, offset: 1 }} className="align-self-end mt-4 mt-xl-0">
     {/* <Link to="/" className="img-landing-banner">
      <img className="img-fluid" src={isDark ? dashboardDark : dashboard} alt="" />
     </Link> */}
    </Col>
   </Row>
  </Section>
 );
};

export default Hero;
